import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7e614bf4"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Settings", -1))
const _hoisted_2 = { class: "setting" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "openaiToken" }, "OpenAI Token:", -1))
const _hoisted_4 = { class: "setting" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "chatModel" }, "Chat Model:", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "gpt-4o" }, "GPT-4o", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "gpt-4o-2024-08-06" }, "gpt-4o-2024-08-06", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "gpt-4o-mini" }, "GPT-4o-mini", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "gpt-3.5-turbo" }, "GPT-3.5 Turbo", -1))
const _hoisted_10 = [
  _hoisted_6,
  _hoisted_7,
  _hoisted_8,
  _hoisted_9
]
const _hoisted_11 = { class: "setting" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "realtimeModel" }, "Realtime Model:", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "gpt-4o-realtime-preview-2024-10-01" }, "gpt-4o-realtime-preview-2024-10-01", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "gpt-4o-realtime-preview-2024-12-17" }, "gpt-4o-realtime-preview-2024-12-17", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "gpt-4o-mini-realtime-preview-2024-12-17" }, "gpt-4o-mini-realtime-preview-2024-12-17", -1))
const _hoisted_16 = [
  _hoisted_13,
  _hoisted_14,
  _hoisted_15
]
const _hoisted_17 = { class: "pair-section" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Pair new device", -1))
const _hoisted_19 = { class: "setting" }
const _hoisted_20 = { class: "modal-buttons" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "modal-overlay",
    onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
  }, [
    _createElementVNode("div", {
      class: "modal-content",
      onClick: _cache[7] || (_cache[7] = _withModifiers(() => {}, ["stop"]))
    }, [
      _hoisted_1,
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _withDirectives(_createElementVNode("input", {
          type: "text",
          id: "openaiToken",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.localSettings.openAiApiKey) = $event))
        }, null, 512), [
          [_vModelText, _ctx.localSettings.openAiApiKey]
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _withDirectives(_createElementVNode("select", {
          id: "chatModel",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.localSettings.chatModel) = $event))
        }, _hoisted_10, 512), [
          [_vModelSelect, _ctx.localSettings.chatModel]
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _hoisted_12,
        _withDirectives(_createElementVNode("select", {
          id: "realtimeModel",
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.localSettings.realtimeModel) = $event))
        }, _hoisted_16, 512), [
          [_vModelSelect, _ctx.localSettings.realtimeModel]
        ])
      ]),
      _createElementVNode("div", _hoisted_17, [
        _hoisted_18,
        _createElementVNode("div", _hoisted_19, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.newPairCode) = $event)),
            maxlength: "6",
            placeholder: "Enter 6-digit code"
          }, null, 512), [
            [_vModelText, _ctx.newPairCode]
          ])
        ]),
        _createElementVNode("button", {
          onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.pairDevice && _ctx.pairDevice(...args)))
        }, "Pair")
      ]),
      _createElementVNode("div", _hoisted_20, [
        _createElementVNode("button", {
          onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.saveSettings && _ctx.saveSettings(...args)))
        }, "Save"),
        _createElementVNode("button", {
          onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
        }, "Cancel")
      ])
    ])
  ]))
}